/**
 * Normalizes a potentially stale range to fit within the current CodeMirror document.
 * @internal
 */
export function getRangeWithinDocument(
  range: { from: number; to: number },
  documentLength: number,
) {
  // NaN propagates through Math.min/max unchanged, producing {from: NaN, to: NaN}.
  // Map it to 0 before clamping; ±Infinity is handled correctly by the clamps below.
  const safeFrom = Number.isNaN(range.from) ? 0 : range.from;
  const safeTo = Number.isNaN(range.to) ? 0 : range.to;

  const from = Math.min(safeFrom, safeTo);
  const to = Math.max(safeFrom, safeTo);

  return {
    from: Math.max(0, Math.min(documentLength, from)),
    to: Math.max(0, Math.min(documentLength, to)),
  };
}
